<template>
  <div>
    <com-table :columns="columns" :api="api" ref="tableRef" :default-params="defaultParams">
      <template #status="row">
          <el-switch
            @change="handleEditStatus(row.data)"
            v-model="row.data.status"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </template>
      <template #createTime="row">
        <div>
          {{ row.data.createTime | formatDate }}
        </div>
      </template>
      <template #operation="row">
        <el-button type="primary " @click="handleDetail(row.data)" class="mb-5px" size="mini"
          >查看</el-button
        >
        <el-button type="primary " @click="handleEdit(row.data)" class="mb-5px" size="mini"
          >编辑</el-button
        >
        <el-button type="danger" @click="handleDel(row.data)" class="mb-5px" size="mini"
          >删除</el-button
        >
      </template>
    </com-table>
  </div>
</template>

<script>
import { monthCardListApi, delMonthCardApi, updateStatus } from '@/api/package-card'

export default {
  props: {
    model: {
      type: String,
      default: ''
    },
    defaultParams: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      api: monthCardListApi,
      columns: [
        {
          label: '编号',
          prop: 'number'
        },
        {
          label: '套餐卡名称',
          prop: 'name'
        },
        {
          label: '关联小区',
          prop: 'refResidentailAreaNames'
        },
        {
          label: '已售数量',
          prop: 'soldCount'
        },
        {
          label: '销售金额',
          prop: 'soldAmount'
        },
        {
          label: '退款数量',
          prop: 'refundCount'
        },
        {
          label: '退款金额',
          prop: 'refundAmount'
        },
        {
          label: '状态',
          prop: 'status',
          type: 'slot',
          slotName: 'status'
        },
        {
          label: '创建人',
          prop: 'refCreateUserName'
        },
        {
          label: '创建时间',
          prop: 'createTime',
          minWidth: '120',
          type: 'slot',
          slotName: 'createTime'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation',
          fixed: 'right',
          minWidth: '180'
        }
      ]
    }
  },
  methods: {
    init() {
      this.$refs.tableRef.init()
    },
    handleDetail(row) {
      this.$router.push({ path: 'package-card-detail', query: { id: row.code } })
    },
    handleEdit(row) {
      this.$router.push({ path: 'package-card-edit', query: { id: row.code } })
    },
    handleDel(row) {
      this.$confirm('是否确认删除这条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const param = {
            code: row.code
          }
          delMonthCardApi(param).then(() => {
            this.$refs.tableRef.getList()
          })
        })
        .catch(() => {})
    },
    search(val) {
      this.$refs.tableRef.search(val)
    },

    async handleEditStatus(row) {
      const params = {
        code: row.code,
        status: row.status
      }

      updateStatus(params).then(() => {
        this.$message.success('操作成功')
        this.$refs.tableRef.getList()
      }).catch((err) => {
        this.$message.success(err.desc)
      })
    },
  }
}
</script>

<style lang="scss" scoped></style>
